import React from "react";
import { graphql } from "gatsby";
import Layout from "../layouts/default";
import BGImageHero from "../sections/BGImageHero";
import Statement from "../sections/Statement";
import BaldJourneyStage from "../components/BaldJourneyStage";
import { Helmet } from "react-helmet";

export const query = graphql`
  {
    contentfulAboutTheBaldJourney {
      backgroundHero {
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      baldJourneyStatement {
        baldJourneyStatement
      }
      stages {
        stage
        illustration {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        icon {
          file {
            url
          }
        }
        quote
        stageDescription {
          stageDescription
        }
        color
        useLightText
      }
      hatsOffStatement {
        hatsOffStatement
      }
    }
  }
`;

export default function BaldJourney({ data, location }) {
  const baldJourney = data.contentfulAboutTheBaldJourney;

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>The Bald Journey</title>
      </Helmet>
      <BGImageHero
        text="The Bald Journey"
        image={baldJourney.backgroundHero.fluid}
      />
      <Statement text={baldJourney.baldJourneyStatement.baldJourneyStatement} />
      <div>
        {baldJourney.stages.map((stage) => (
          <BaldJourneyStage
            stage={stage.stage}
            quote={stage.quote}
            icon={stage.icon.file.url}
            illustration={stage.illustration.fluid}
            description={stage.stageDescription.stageDescription}
            color={stage.color}
            light={stage.useLightText}
          />
        ))}
      </div>
      <Statement
        header="Hats off to you!"
        text={baldJourney.hatsOffStatement.hatsOffStatement}
        dark={true}
      />
    </Layout>
  );
}
